module.exports = __webpack_public_path__ + "static/img/part3-img.d8b0fc3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/part3-img.png
// module id = UvmL
// module chunks = 1